export const faQ = [
    {
        nr: 0,
        name: 'Suche nach den häufig gestellten Fragen...',
        intl: '',
        value: '',
        keywords: ['']
    },
    {
        nr: 1,
        name: 'Ich habe die PADB noch nicht benutzt. Wo finde ich das System?',
        intl: 'Ich habe die PADB noch nicht benutzt. Wo finde ich das System?',
        value: `Geben Sie zur Nutzung der PADB die folgende URL in Ihren Browser ein: https://padb.porsche.services/flow2/auth`,
        keywords: ['PADB', 'System']
    },
    {
        nr: 2,
        name: 'Wie kann ich mich in meinen PADB-Account einlogen?',
        intl: 'Wie kann ich mich in meinen PADB-Account einlogen?',
        value: `Sie melden sich per Porsche SSO an. Bei der Erstanmeldung erhalten Sie einen niedrigen User-Level. Wenn Sie einen anderen User-Level erhalten möchten, bitte wenden Sie sich an padb.support@porsche.de (Mail Adresse GOH Accounts bei Porsche)`,
        keywords: ['Account', 'Person']
    },
    {
        nr: 3,
        name: 'Ich habe ein aktives Benutzerkonto, kann mich aber nicht an mein Passwort erinnern.',
        intl: 'Ich habe ein aktives Benutzerkonto, kann mich aber nicht an mein Passwort erinnern.',
        value: `Sie melden sich per Porsche SSO an. Bitte folgen Sie dem SSO Prozess für “Passwort vergessen”.`,
        keywords: ['']
    },
    {
        nr: 4,
        name: 'Ich bin es nicht gewohnt, mit der PADB zu arbeiten. Wo finde ich Support und...',
        intl: 'Ich bin es nicht gewohnt, mit der PADB zu arbeiten. Wo finde ich Support und andere nützliche Informationen?',
        value: `Innerhalb der PADB erreichen Sie das Support-Team über das „?“ ganz rechts oben auf der Hauptseite. Hier finden Sie auch Tutorial Videos und PDF Handouts.`,
        keywords: ['']
    },
    {
        nr: 5,
        name: 'Ich möchte einen Blick auf die spezifischen Details eines Datensatzes werfen...',
        intl: 'Ich möchte einen Blick auf die spezifischen Details eines Datensatzes werfen. Wie kann ich das machen?',
        value: `Bestimmte Daten eines Eintrages können durch einen Doppelklick auf das Vorschaubild der Datei angezeigt werden. Rechts neben dem Thumbnail finden Sie allgemeine Informationen (z.B. PADB-ID, Objekt, Archivnummer, Titel, Beschreibung, Laufzeit, ...), darunter sind mehrere Reiter die mit einem Doppelklick geöffnet werden können.
Je nach "Objekt" des Eintrages finden sich unterschiedliche Reiter mit unterschiedlichen Metadaten. Bei einem Eintrag vom Objekt "Historisches Bildarchiv" findet sich etwa der Reiter "Foto" mit fotospezifischen Metadaten wie Fotograf, Blickwinkel, Witterung, ...
Unterhalb der Reiter finden sich die Flächen für Media Files (hier werden alle am Eintrag angehangenen Medien aufgelistet) und Verwandte Medien (hier finden sich, falls vorhanden, Verknüpfungen mit anderen Einträgen).
Weiter finden sich in der Titelleiste die Icons für Restore Clip (zwei gestaffelte Karten) über welches frühere Werte der Metadatenfelder eingesehen werden können; und für Verlauf (Uhr mit Pfeilkreis) über welchen Aktionen wie das Hinzufügen eines weiteren Mediums am Eintrag nachverfolgt werden können.`,
        keywords: ['']
    },
    {
        nr: 6,
        name: 'Was ist ein Media File?',
        intl: 'Was ist ein Media File?',
        value: `In der PADB befinden sich verschiedene Assettypen wie Videos und Fotos. Pro Eintrag (= ein Eintrag ist ein jeweils separater Container mit eigener ID, Archiv Nummer, Metadaten und Medien) finden Sie eine oder multiple Quelldateien (“Source”) plus pro Quelldatei technische Varianten (“Derivate”).
Beim öffnen eines Eintrages sehen Sie links oben ein Preview (Vorschaubild) zur Orientierung. Mit Klick auf das Panle “Media Files” (mittig, unten) sehen Sie alle Medien / Qualitäten dieses Eintrages aufgelistet. Mit den Operatoren rechts davon können Sie einzelne Dateien öffnen / herunterladen, versenden, etc
.`,
        keywords: ['']
    },
    {
        nr: 7,
        name: 'Ich habe einen Level 2 Zugang und habe ein Video / Foto hochgeladen, aber ich kann es...',
        intl: 'Ich habe einen Level 2 Zugang und habe ein Video / Foto hochgeladen, aber ich kann es in der PADB nach dem Upload nicht finden. Wo finde ich mein Video / Foto?',
        value: `Jedes Asset, dass von einem User mit dem Level 2 hochgeladen wird, muss von einem User mit dem Level 3 freigegeben werden. Solange der User Level 3, der beim Upload im Feld „Freizugeben durch“ angegeben wurde, das Asset nicht kontrolliert und freigegeben hat, ist es öffentlich nicht sichtbar. Der angegebene User Level 3 wird nach dem vollständigen Upload automatisch über Ihren Upload und der Bitte nach Freigabe vom System informiert. Erst nachdem das Asset den Status „Freigegeben“ erhalten hat, ist es für alle User der PADB sichtbar.`,
        keywords: ['']
    },
]

export const sQ = [
    {
        name: 'Suche nach den häufig gestellten Fragen...',
        intl: '',
        value: '',
        keywords: ['']
    },
    {
        name: 'Ich habe die Profisuche noch nie benutzt. Wie kann ich starten?',
        intl: 'Ich habe die Profisuche noch nicht benutzt. Wie kann ich starten?',
        value: `Man kann Felder aus der linken Liste ins Suchfeld ziehen, um Suchfelder zu bilden. Wenn man mehrere Felder hat, kann man die Verknüpfung wählen.`,
        keywords: []
    },
    {
        name: 'Wie kann ich mehrere Felder gruppieren?',
        intl: 'Wie kann ich mehrere Felder gruppieren?',
        value: `Mit Shift kann man mehrere Felder anwählen und gruppieren.`,
        keywords: []
    },
    {
        name: 'Wie kann ich meine Suche speichern?',
        intl: 'Wie kann ich meine Suche speichern?',
        value: `Mit "Speichern" kann man der Suche eine Namen geben und sie speichern.`,
        keywords: []
    },
];

export const pHelp = [
    {
        nr: 1,
        value: `Die “Profisuche” erlaubt es Ihnen, komplexe Suchen eigenständig zusammenzustellen, zu speichern und zu nutzen.`
    },
    {
        nr: 2,
        value: `Grundprinzip: Links im Panel finden sich alle Metadaten-Felder die suchbar sind. Per Drag & Drop in das mittige Hauptfeld können Sie diese in die Suche einbeziehen. Sie erstellen sich eine eigene Suchmaske bestehend aus den Feldern, die Sie nutzen möchten.`
    },
    {
        nr: 3,
        value: `Pro Feld können Sie dieses nun, je nach Metadaten-Typ, per Eingabe oder Auswahl aus einem Dropdown befüllen.`
    },
    {
        nr: 4,
        value: `Sie können in einem dritten Schritt die Bedingungen einer Kette von Metadaten festlegen, indem Sie die Bedingung “und” (beide / alle Daten müssen vorhanden sein) sowie “oder” (auch einzelne Treffer sind zulässig) aktivieren. Als Default ist immer der Wert als “oder” angegeben.`
    },
    {
        nr: 5,
        value: `“Search” startet die Suchen und die Seite springt auf die Ergebnisliste.`
    },
    {
        nr: 6,
        value: `“Speichern” erlaubt es Ihnen dieser Suche einen eigenen Namen zu geben und abzuspeichern.`
    },
    {
        nr: 7,
        value: `Die gespeicherten Suchen finden sich als Dropdown mittig in der oberen Leiste. Wählen Sie aus dem Dropdown eine aus und klicken Sie “Laden” um diese anzuzeigen.`
    },
    {
        nr: 8,
        value: `Wenn Sie eine vorhandene Suche ändern möchten und diese Änderungen unter dem gespeichertem Namen speichern möchten, klicken Sie “Aktualisieren”.`
    },
    {
        nr: 9,
        value: `Anmerkung: alle gespeicherten Suchen sind individuell und Ihre Suchen werden nur Ihnen angezeigt.`
    },
]

export const upQHelp = [
    {
        nr: 1,
        label: 'ca.',
        value: `ca. MM.YYYY macht Einträge findbar, bei Suchdatum größer oder kleiner 3 Monate. ca. YYYY macht Einträge findbar, bei Suchdatum größer oder kleiner 5 Jahre. Funktioniert bei Einzeldatum und Zeitspannen.`
    },
    {
        nr: 2,
        label: 'nach',
        value: `Macht Einträge findbar, bei denen das Suchdatum > YYYY bzw. > MM.YYYY bzw. > DD.MM.YYYY ist. Funktioniert nur bei Einzeldatum.`
    },
    {
        nr: 3,
        label: 'ab',
        value: `Macht Einträge findbar, bei denen das Suchdatum >= YYYY bzw. >= MM.YYYY bzw. >= DD.MM.YYYY ist. Funktioniert nur bei Einzeldatum.`
    },
    {
        nr: 4,
        label: 'vor',
        value: `Macht Einträge findbar, bei denen das Suchdatum < YYYY bzw. < MM.YYYY bzw. < DD.MM.YYYY ist. Funktioniert nur bei Einzeldatum.`
    },
    {
        nr: 5,
        label: 'bis',
        value: `Macht Einträge findbar, bei denen das Suchdatum <= YYYY bzw. <= MM.YYYY bzw. <= DD.MM.YYYY ist. Funktioniert nur bei Einzeldatum.`
    }
]